import { FC, useRef, useState, DragEvent, ChangeEvent } from "react";
import { ReactComponent as UploadFileIcon } from "../../../assets/icons/uploadImage.svg";

interface UploadZoneProps {
  onFilesSelected: (files: FileList) => void;
  acceptedFormats: string[];
  remainingSlots: number;
  mode: "single" | "multiple";
}

export const UploadZone: FC<UploadZoneProps> = ({
  onFilesSelected,
  acceptedFormats,
  remainingSlots,
  mode,
}) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [dragActive, setDragActive] = useState(false);

  const handleDrag = (e: DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(e.type === "dragenter" || e.type === "dragover");
  };

  const handleDrop = (e: DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files?.length) onFilesSelected(e.dataTransfer.files);
  };

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files?.length) onFilesSelected(e.target.files);
  };

  return (
    <div className="relative" onDragEnter={handleDrag}>
      <input
        ref={inputRef}
        type="file"
        accept={acceptedFormats.join(",")}
        multiple={mode === "multiple"}
        onChange={handleChange}
        className="hidden"
      />

      <label
        className={`flex items-center justify-center border-2 border-dashed rounded-lg py-8 cursor-pointer transition-all ${
          dragActive ? "border-blue-500 bg-blue-50" : "border-gray-300 bg-gray-50 hover:border-blue-400 hover:bg-blue-50"
        }`}
      >
        <div className="text-center">
          <UploadFileIcon className="mx-auto mb-3" />
          <p className="text-sm text-gray-600 mb-2">
            {mode === "single" ? "یک فایل انتخاب کنید" : "فایل را بکشید و رها کنید"}
          </p>
          <button
            type="button"
            onClick={() => inputRef.current?.click()}
            className="text-blue-600 underline text-sm font-medium"
          >
            {mode === "single" ? "انتخاب فایل" : "یا فایل انتخاب کنید"}
          </button>
          {mode === "multiple" && (
            <p className="text-xs text-gray-500 mt-2">(حداکثر {remainingSlots} فایل دیگر)</p>
          )}
        </div>
      </label>

      {dragActive && mode === "multiple" && (
        <div
          className="absolute inset-0 rounded-lg"
          onDragEnter={handleDrag}
          onDragLeave={handleDrag}
          onDragOver={handleDrag}
          onDrop={handleDrop}
        />
      )}
    </div>
  );
};
